import { Divider, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import * as React from 'react';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface SubmitSuccessDialogProps {
  open: boolean;
  handleClose: VoidFunction;
}

export default function SubmitSuccessDialog( {open, handleClose, }: SubmitSuccessDialogProps ) {

  return (
      <Dialog
        TransitionComponent={Transition}
        open={open}
        onClose={handleClose}
        aria-labelledby="submit-success-dialog"
        aria-describedby="submit-success-dialog"
      >
        <DialogTitle id="submit-success-dialog">
          <div>
            <Typography variant="h5" >Your post has been uploaded!</Typography> {/*typography within dialog title must be wrapped in a div to avoid error https://github.com/mbrn/material-table/issues/653*/}
          </div>
        </DialogTitle>
        <Divider variant="middle" />
        {/* <DialogContent>
          <DialogContentText id="alert-dialog-description">
            삭제하면, 회복할 수 없습니다.
          </DialogContentText>
        </DialogContent> */}
        <DialogActions>
          <Button onClick={handleClose} autoFocus>See your post!</Button>
        </DialogActions>
      </Dialog>
  );
}
